export default {"src":"/_next/static/media/Napoli.04cb6d46.svg","height":566,"width":566,"blurWidth":0,"blurHeight":0};